/**
 * @generated SignedSource<<7db1bbccd6acc4997ae6299ae11b3718>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StarButtonWhiteboardCardStarFragment$data = {
  readonly viewer: {
    readonly favoritedSummary: {
      readonly isFavorite: boolean;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "StarButtonWhiteboardCardStarFragment";
};
export type StarButtonWhiteboardCardStarFragment$key = {
  readonly " $data"?: StarButtonWhiteboardCardStarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"StarButtonWhiteboardCardStarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "StarButtonWhiteboardCardStarFragment",
  "selections": [
    {
      "concreteType": "ConfluenceContentViewerSummary",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "concreteType": "ConfluenceFavoritedSummary",
          "kind": "LinkedField",
          "name": "favoritedSummary",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavorite"
            }
          ]
        }
      ]
    }
  ],
  "type": "ConfluenceWhiteboard"
};

(node as any).hash = "85a390774d106b96e51ecf04f0dab5fb";

export default node;
